import { useLocation } from 'react-router-dom';
import { useNavGroupItems } from '../navItems';
import { NavItemLink, isNavItemSelected } from './';

export interface TopNavProps {
  onClick: () => void;
}

export const TopNav = ({ onClick }: TopNavProps) => {
  const location = useLocation();
  const items = useNavGroupItems('top');

  return (
    <>
      {items.map(({ icon, selected, text, to }) => (
        <NavItemLink
          icon={icon}
          key={to}
          onClick={onClick}
          selected={isNavItemSelected(location.pathname, selected ?? to)}
          text={text}
          to={to}
        />
      ))}
    </>
  );
};
